module.exports = __webpack_public_path__ + "static/media/prints.05dad445.jpg";